import React from "react";
import logo from "../images/matecareer_logo.webp";
import "../css/Sidebar.css";

export default function Sidebar({ menuItems, isOpen, setIsOpen, setSelectedMenu, selectedMenu }) {
  return (
    <div
      className={`sidebar ${isOpen ? "open" : "collapsed"}`}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      {/* Header */}
      <div className="sidebar-header">
        {isOpen
          ? <img src={logo} alt="Logo" className="sidebar-logo" />
          : (
            <div className="sidebar-icon-placeholder">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect x="1" y="1" width="6" height="6" rx="1.5" fill="rgba(255,255,255,0.6)" />
                <rect x="9" y="1" width="6" height="6" rx="1.5" fill="rgba(255,255,255,0.6)" />
                <rect x="1" y="9" width="6" height="6" rx="1.5" fill="rgba(255,255,255,0.6)" />
                <rect x="9" y="9" width="6" height="6" rx="1.5" fill="rgba(255,255,255,0.6)" />
              </svg>
            </div>
          )
        }
      </div>

      {/* Nav */}
      <nav className="menu">
        {menuItems.map((item, index) => {
          const isActive = selectedMenu === item.label;
          return (
            <button
              key={index}
              className={`menu-item ${isActive ? "active" : ""}`}
              onClick={() => {
                setSelectedMenu(item.label);
                if (item.onClick) item.onClick();
              }}
              title={!isOpen ? item.label : ""}
            >
              <span className="icon">{item.icon}</span>
              <span className="text">{item.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}